module.exports = __webpack_public_path__ + "static/tyrant03-sq-7c2a8ed758c33fd81ec48d0a278bae05.png";